module.exports = __webpack_public_path__ + "img/54000.6c61964a.jpg";